'use strict'

var Marionette = require('marionette')
var App = require('app')
var DialogComponent = require('src/components/dialog-view')

const reportConstants = require('../reportConstants')

/**
 * Dialog body view
 * -----------------------------------------------------------------------------
 * Body of the dialog
 */
var DialogBody = DialogComponent.Body.extend({
  template: require('./templates/body.html'),
  templateContext: function () {
    var self = this
    let model = self.getOption('model')

    return {
      getDeviceTypes: App.TemplateHelpers.getDeviceTypes,
      getClients: App.TemplateHelpers.getClients,
      getUserRoles: App.TemplateHelpers.getUserRoles,
      userHasRole: App.TemplateHelpers.userHasRole,
      recipientsCommaSep: function () {
        let recipients = model.get('recipients')
        if (recipients) return model.get('recipients').join(', ')
      },
      getReportTypes: function () {
        return reportConstants.types
      },
      getIntervals: function () {
        return reportConstants.intervals
      }
    }
  }
})

/**
 * Dialog view
 * -----------------------------------------------------------------------------
 * The dialog view
 */
var DialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-api-key',
  onRender: function () {
    var bodyView = new DialogBody({model: this.model, collection: this.collection})
    this.showChildView('bodyRegion', bodyView)
  }
})

module.exports.Layout = DialogView



// WEBPACK FOOTER //
// ./js/modules/client-mailreports/edit_new/view.js